"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceInfo = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var PriceInfo = function PriceInfo(props) {
  var product = props.product;
  return !!product.price && /*#__PURE__*/_react.default.createElement(_core.Box, {
    fontSize: "1rem",
    fontWeight: 600,
    letterSpacing: 1
  }, product.price, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "\u20AC",
    defaultMessage: "\u20AC"
  }));
};
exports.PriceInfo = PriceInfo;